module.exports = __webpack_public_path__ + "static/media/carta_1.8cc657c6.jpg";